import { isPlatform } from '@ionic/core';
import { IonFooter } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';

import {
  UiButton,
  UiButtonColorType,
  UiButtonRoundType,
  UiButtonSizeType,
} from '@/components/ui/Button';

import './DominateFooter.scss';

export const DominateFooter: React.FC<{
  onContinue: () => void;
  disabled?: boolean;
  hidden?: boolean;
  buttonColor?: UiButtonColorType;
  buttonRadius?: UiButtonRoundType;
  buttonSize?: UiButtonSizeType;
  buttonClassName?: string;
  buttonText?: string;
  quoteText?: string;
  variant?: 'simple' | 'with-quotes';
}> = ({
  onContinue,
  disabled,
  hidden,
  buttonColor = 'primary',
  buttonRadius = 'md',
  buttonSize = 'large',
  buttonClassName,
  buttonText,
  quoteText,
  variant = 'simple',
}) => {
  React.useEffect(() => {
    const handleNextStep = (event: KeyboardEvent) => {
      if (event.code === 'Space' && !disabled && !hidden) {
        onContinue();
      }
    };

    if (isPlatform('desktop')) {
      document.addEventListener('keypress', handleNextStep);
    }

    return () => {
      if (isPlatform('desktop')) {
        document.removeEventListener('keypress', handleNextStep);
      }
    };
  }, [hidden, disabled, onContinue]);

  return (
    <IonFooter
      className={classNames('dominate-footer', {
        hidden,
      })}
    >
      {variant === 'with-quotes' ? (
        <div className="dominate-footer__container">
          <div className="dominate-footer__quotes">
            <img src="/assets/quotes.svg" alt="quotes" />
          </div>
          {quoteText && (
            <div className="dominate-footer__text">{quoteText}</div>
          )}
          <UiButton
            disabled={disabled}
            expand="full"
            round={buttonRadius}
            size={buttonSize}
            color={buttonColor}
            className={classNames('dominate-footer__button', buttonClassName)}
            onClick={onContinue}
            TEST_ID="dominate-next"
          >
            {buttonText || 'Continue'}
          </UiButton>
        </div>
      ) : (
        <UiButton
          disabled={disabled}
          expand="full"
          round={buttonRadius}
          size={buttonSize}
          color={buttonColor}
          className={classNames('dominate-footer__button', buttonClassName)}
          onClick={onContinue}
          TEST_ID="dominate-next"
        >
          {buttonText || 'Continue'}
        </UiButton>
      )}
    </IonFooter>
  );
};
